import { InvoicePaymentDto } from '../invoicePayment.dto';

export class FireOpenInvoicePaymentResponse {
  message?: string;
  success: boolean;
  invoicePaymentDto?: InvoicePaymentDto;
  code?: string;
}
